export default {
  id: "topSalesByRevenue",
  name: "",
  description: "",
  report: {
    name: "Top sales by revenue",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: ["Sale.sale_stamp", "Sale.sale_time"],
      measures: ["Sale.total_revenue", "Sale.units_sold"],
      sort: {
        direction: "desc",
        by: "Sale.total_revenue",
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
